export default t => ({
  "ui:order": ["typeId", "file"],
  file: {
    "ui:options": {
      tooltip: {
        description: t("SUPPROTED_FILE_TYPES_DESCRIPTION"),
        id: "file-tooltip",
        size: "medium",
      },
    },
  },
});
